
// used for error highlighting of tabs

const fields = {
    'job_reference': 'summary',
    'name': 'summary',
    'is_purchase_order_required':'summary',
    'completion_date':'summary',
    'start_date':'summary',
    'artwork_received_date':'summary',
    'purchase_order':'summary',
    'invoice':'summary',
    'notes':'summary',
    'posters_received':'summary',
    'media_production_notes':'mediaProductions',
    'is_vat_exempt':'summary',
    'currency':'summary',
    'currencies':'summary',
    'clientSubType':'summary',
    'clientCompany':'summary',
    'clientCompanyContact':'summary',
    'status':'summary',
    'discount_percentage':'summary',
    'salesTeam':'summary',
    'ourContact':'summary',
    'authorizationFiles':'summary',
    'artworkFiles':'summary',
    'portfolio_hash':'portfolio',
    'portfolio_show_impacts':'portfolio',
    'portfolio_small_sites':'portfolio',
    'portfolio_summary':'portfolio',
    'portfolio_title':'portfolio',
    'previewTags':'portfolio'
};


export function campaignFieldsToTabs(errors) {
    const errorTabs = {};
    Object.keys(errors).forEach((v)=>{
        v = v.replace(/\[\d+\]/,'');
        const p = v.split('.');
        if(p.length>1) {
            errorTabs[p[0]] = true;
            return;
        }
        if(fields[v]) {
            errorTabs[fields[v]] = true;
        }
    });
    return errorTabs;
}
